module.exports = __webpack_public_path__ + "a501f163185f88c56fb9b43818c189b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/moscow.jpg
// module id = 603
// module chunks = 0